// NG 2
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
//import { Route, Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AuthenticationService } from '../../services/authentication.service';
import { EntityService } from '../../services/entity.service';
import { AuthGuardService } from '../../services/auth-guard.service';
import { SharedService } from '../../services/shared.service';
import { FoucsChangeService } from '../../services/focuschange.service';
// APP
import { Account } from '../../viewmodel';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    providers: [EntityService, DatePipe]

})
export class HomeComponent implements OnInit {
    title: string = 'Home';
    applications: Array<any>;

    isDesc: boolean = true;
    column: string = 'ProjectID';
    direction: number = -1;
    pageError: any = [];
    pageSuccess: any = [];
    appName: string = '';
    isIncompleteProfile: boolean = false;
    //successText: string = 'Your application was successfully submitted.'; 
    showDeleteAppPopup: boolean = false;
    deleteAppId: number = 0;

    constructor(private router: Router
        , private entityService: EntityService
        , private sharedService: SharedService
        , private activatedRoute: ActivatedRoute
        , private authenticationService: AuthenticationService
        , private datePipe: DatePipe
        , private foucsChangeService: FoucsChangeService) {

    }

    ngOnInit() {

        // Clear any selected Id
        this.sharedService.manageSession("home");
        //var user = JSON.parse(this.sharedService.getData("loggedInUser"));
        //this.getAccountByUserId(user.UserID);        
        // var route = this.activatedRoute.url; 
        var urlparam = this.activatedRoute.snapshot.params["submit"];
        if (urlparam === 'IP') {
            this.isIncompleteProfile = true;
            this.foucsChangeService.changeFocus(false);
        }
        else {

            this.getUserProjects();
        }

        if (urlparam === 'save') {
            this.showSuccess('Your information was successfully saved.');
        }

    }

    navigate() {

        // Clean Ids to create new project        
        this.sharedService.removeData('id');
        this.router.navigate(["/navigator"]);
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();
    }

    changeOrder(property) {
        if (this.column == property) {
            this.isDesc = !this.isDesc;
        }
        else {
            this.isDesc = true;
        }
        this.column = property;
        this.direction = this.isDesc ? 1 : -1;
        //if (this.direction == -1) {
        //    this.column = "-" + this.column;
        //}
        //else {
        //    this.column.replace("-", "");
        //}   
    }

    viewDetailByKey(e, projectId, projectName, status, mood) {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode == '13') {
            this.viewDetail(projectId, projectName, status, mood);
            e.stopPropagation();
        }
    }

    viewDetail(projectId, projectName, status, mood) {
        var idLabel = "ID - " + projectId;
        this.sharedService.setData('id', JSON.stringify({ 'projectId': projectId, 'appName': projectName, appIdLabel: idLabel, 'appStatus': status, 'appMode': mood }));

        if (status == 'Draft') {
            this.router.navigate(["/entity/application"]);
        }
        else {
            this.router.navigate(["/entity/application"], { queryParams: { activeTab: 'FileUpload' } });
        }
    }

    getSubmissionDate(date, status) {

        var retDate = '';
        if (status == 'Draft') {
            return '';
        }

        retDate = this.datePipe.transform(date, 'MM/dd/yyyy');
        return retDate;
    }

    getUserProjects() {
        this.entityService.getUserProjects()
            .subscribe(
                successResp => {
                    if (!successResp.Success) {
                        this.showError(successResp.StatusMessage);
                    }
                    else {

                        this.applications = successResp.Result;

                        if (this.applications && this.applications.length > 0) {
                            for (var i = 0; i < this.applications.length; i++) {
                                if (this.applications[i].ApplicationStatus == "Draft") {
                                    this.applications[i].SubmissionDate = "1900-01-01";
                                }
                            }
                            this.column = "ProjectID";
                            this.isDesc = false;
                        }
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage)
                });
    }

    /////////Delete Application ////////////
    deleteAppPopupByKey(deleteApplicationId, btnId, e) {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode == '13') {
            this.deleteAppPopup(deleteApplicationId, btnId, e);
            // e.stopPropagation();
        }
    }

    deleteAppPopup(deleteApplicationId, btnId, event) {
        document.getElementById(btnId).blur();
        this.showDeleteAppPopup = true;
        this.deleteAppId = deleteApplicationId;
        this.foucsChangeService.changeFocus(false);
        event.stopPropagation();
    }

    cancelDeleteApp(event) {
        this.showDeleteAppPopup = false;
        this.deleteAppId = 0;
        this.foucsChangeService.changeFocus(true);
        event.stopPropagation();
    }


    deleteApplication(deleteAppId, $event) {

        if (deleteAppId > 0) {
            this.showDeleteAppPopup = false;
            this.foucsChangeService.changeFocus(true);
            this.entityService.DeleteApplicationAndCleanup(deleteAppId)
                .subscribe(
                    success => {
                        if (!success.Success) {
                            this.showError(success.StatusMessage);
                            this.deleteAppId = 0;
                        }
                        else {
                            //partial refresh                        
                            this.deleteAppId = 0;
                            this.getUserProjects();
                        }
                    },
                    error => {
                        if (error.status == 401)
                            this.router.navigateByUrl('/login?session=0');

                        this.deleteAppId = 0;
                        this.showError(error.ExceptionMessage);
                    })
        }
    }

    overdelete(e) {
        let postion = e.clientY;
        if (postion > 540) {
            e.currentTarget.parentNode.classList.add('tooltipUp');
        }
        else {
            e.currentTarget.parentNode.classList.remove('tooltipUp');
        }
    }

    updateProfile() {

        this.isIncompleteProfile = false;
        this.foucsChangeService.changeFocus(true);
        var profileUrlLink = '';
        this.authenticationService.getUpdateProfile()
            .subscribe(profileUrl => {
                profileUrlLink = profileUrl.d;
                window.location.href = profileUrlLink;
            });
    }

    cancelProfile(event) {
        this.isIncompleteProfile = false;
        this.foucsChangeService.changeFocus(true);
    }

    displayEditIcon(application: any) {
        return application.ApplicationMode == 'Edit' &&
            application.ApplicationStatus != 'Pending Execution' &&
            application.ApplicationStatus != 'Executed' &&
            application.ApplicationStatus != 'Withdrawn';
    }    
}
